// src/admin/components/EmptyState.jsx
//
// Shown instead of an empty table when there is no data to display.

import React from 'react';

export default function EmptyState({
  title = 'No camps found',
  description = 'There are no active camps for this date.',
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-[#E2E8E8] bg-white px-6 py-12 text-center">
      <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#E8F8F7] text-[#11A8A4]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="h-5 w-5"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 13h6m-7 8h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2z" />
        </svg>
      </div>

      <p className="text-sm font-semibold text-[#172B2B]">{title}</p>
      <p className="max-w-xs text-xs text-[#6B7C7C]">{description}</p>
    </div>
  );
}
